import { useState, useContext, useEffect, ChangeEvent, JSX } from 'react'
import { Handle, Position, useReactFlow, NodeResizeControl, NodeResizer } from '@xyflow/react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import DeleteIcon from '@mui/icons-material/Delete';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import {
    TextField,
    IconButton
} from '@mui/material';

function WorkflowLabelNode({ id, data, selected }): JSX.Element {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();
    const [descriptionText, setDescriptionText] = useState<string>(data?.note);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    let node = reactFlowInstance.getNode(id);

    function handleDescriptionChange(e: ChangeEvent<HTMLInputElement>): void {
        setDescriptionText(e.target.value);
        if (!isSaving) {
            setIsSaving(true);
            setTimeout( () => {

                if (node?.data) {
                    node.data.note = e.target.value
                }
                reactFlowInstance.updateNode(id, node.data);
                const nodes = reactFlowInstance.getNodes();
                context.updateLayoutNodes(nodes);
                setIsSaving(false);
            }, 1000 );
        }

    }

    const controlStyle = {
        background: 'transparent',
        border: 'none',
    };

    function handleNodeDelete() {
        let nodes = reactFlowInstance.getNodes();
        let updatedNodes = nodes.filter( (node: any): boolean => node.id !== id );
        context.updateLayoutNodes(updatedNodes);
    }

    return (
        <>
            <NodeResizeControl style={controlStyle} minWidth={200} minHeight={100}>
                <AspectRatioIcon />
            </NodeResizeControl>
            <div className={ "workflow-node label-node " } style={ {
                width: node?.width ?? 200,
                height: node?.height ?? 100
            } } >
                <div className="node__layout">
                    <div className="note">
                        <div className="top__title">
                            <span className="label-icon" />
                            <IconButton onClick={ handleNodeDelete } >
                                <DeleteIcon />
                            </IconButton>
                        </div>
                        <div className="nodrag text-area">
                            <TextField
                                multiline
                                value={ descriptionText }
                                onChange={ handleDescriptionChange }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WorkflowLabelNode;